module.exports = __webpack_public_path__ + "static/media/reportIcon.77f5b470.svg";